import type { TooltipProps as MuiTooltipProps } from '@mui/material'
import { IconButton, Tooltip as MuiTooltip } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import type { ReactElement } from 'react'
import { FaInfoCircle } from 'react-icons/fa'

interface TooltipProps extends Omit<MuiTooltipProps, 'title' | 'children'> {
  text: string | React.ReactNode
  icon?: ReactElement
  iconSize?: 'small' | 'medium' | 'large'
  sx?: object
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  tooltipWidth?: number | string
}

const Tooltip = ({
  text,
  icon = (
    <FaInfoCircle size={14} style={{ width: '0.875rem', height: '0.875rem' }} />
  ),
  iconSize = 'small',
  onClick,
  arrow = true,
  placement = 'top',
  sx = {},
  tooltipWidth,
  ...props
}: TooltipProps) => {
  const theme = useTheme()

  return (
    <MuiTooltip
      title={text}
      arrow={arrow}
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            width: tooltipWidth,
            maxWidth: tooltipWidth ? 'none' : undefined,
            whiteSpace: 'pre-line',
            wordWrap: 'break-word',
          },
        },
      }}
      {...props}
    >
      <IconButton
        component="div"
        size={iconSize}
        onClick={onClick}
        sx={{
          color: theme.palette.text.secondary,
          ml: 1,
          p: 0,
          ...sx,
        }}
      >
        {icon}
      </IconButton>
    </MuiTooltip>
  )
}

export default Tooltip
